import { myAxios } from "./axios";

export function getDeals(payload = {}, { page, limit } = {}) {
    const config = {
        params: {
            page,
            limit,
            ...payload,
        },
    };
    return myAxios.get("/deals", config);
}

export function getServices() {
    const res = myAxios.get("/services/");
    if (res.data.length > 0) {
        const services = res.data[0].names.map((name) => ({
            value: name,
            label: name,
        }));
        return services;
    }
    return [];
}


export function getDeal(id) {
    return myAxios.get("/deals/" + id);
}

export function addDeal(data) {
    return myAxios.post("/deals/add/", data);
}

export function editDeal(dealId, data) {
    return myAxios.put("/deals/edit/" + dealId, data);
}

export function deleteDeal(id) {
    return myAxios.delete("/deals/" + id);
}

// export async function getServices() {
//     return await myAxios.get("/services").then((res) =>
//         res.data.flatMap((item) =>
//             item.names.map((name) => ({
//                 label: name,
//                 value: name,
//             }))
//         )
//     );
// }

// export async function getDeliverables() {
//     return await myAxios.get("/deliverables").then((res) =>
//         res.data.map((item) => ({
//             label: item.deliverable,
//             value: item._id,
//         }))
//     );
// }
